'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'floppy-disk';
var width = 448;
var height = 512;
var aliases = [128190,128426,"save"];
var unicode = 'f0c7';
var svgPathData = ['M32 64l0 384 384 0 0-290.7L322.7 64 320 64l0 112 0 16-16 0L80 192l-16 0 0-16L64 64 32 64zM304 320a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z', 'M32 480L0 480l0-32L0 64 0 32l32 0 304 0L448 144l0 304 0 32-32 0L32 480zm384-32l0-290.7L322.7 64 320 64l0 112 0 16-16 0L80 192l-16 0 0-16L64 64 32 64l0 384 384 0zM96 64l0 96 192 0 0-96L96 64zm80 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFloppyDisk = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;